import PromisedResource from './PromisedResource'

export default class AdCampaignSetsResource extends PromisedResource {
  constructor({ remote, client }) {
    super(remote.query(q => q.findRelatedRecords(client, 'adCampaignSets')))
  }
}
